/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Toast_Cancel_PdcInputs */

const vi_pll_toast_cancel_pdc = /** @type {(inputs: Pll_Toast_Cancel_PdcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy phiếu`)
};

/**

* @param {Pll_Toast_Cancel_PdcInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_toast_cancel_pdc = /** @type {((inputs?: Pll_Toast_Cancel_PdcInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Toast_Cancel_PdcInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_toast_cancel_pdc(inputs)
});